(function () {
  'use strict';

  var styleId = 'nmi-bta-minimal-workshop-theme';
  var widgetCss = [
    'html, body, .main-panel { background: #ffffff !important; color: #111111 !important; }',
    'html { color-scheme: light; }',
    'body { margin: 0 !important; font-family: Arial, Helvetica, sans-serif !important; }',
    '.widget-container { width: 100% !important; max-width: none !important; margin: 0 !important; padding: 26px !important; box-sizing: border-box !important; color: #111111 !important; background: #ffffff !important; border: 0 !important; border-radius: 0 !important; box-shadow: none !important; }',
    '.widget-container > div, .sub-panel.inline, .variant-select, .date-picker-container, .time-slot-radio-button-list, .price-container { width: 100% !important; max-width: none !important; box-sizing: border-box !important; }',
    '.sub-panel, .rdp-months, .rdp-month, .rdp-caption, .rdp-table, .rdp-head, .rdp-tbody { color: #111111 !important; background: #ffffff !important; border-radius: 0 !important; box-shadow: none !important; }',
    '.date-picker-container, .rdp { width: 100% !important; max-width: none !important; color: #111111 !important; background: #ffffff !important; border-radius: 10px !important; box-shadow: none !important; }',
    '.rdp-months, .rdp-month, .rdp-table { width: 100% !important; max-width: none !important; }',
    '.widget-title, .titles, .rdp-caption_label, .rdp-head_cell, .timezone-line, .price-container, .price-container span, .widget-container h3, .widget-container h4, .widget-container label { color: #111111 !important; }',
    '.widget-title { margin: 0 0 14px !important; font-family: "Arial Rounded MT Bold", "Trebuchet MS", Arial, sans-serif !important; font-size: 21px !important; font-weight: 900 !important; text-align: left !important; }',
    '.titles { margin-top: 12px !important; font-size: 13px !important; }',
    '.rdp { margin: 12px auto 14px !important; }',
    '.rdp-day { width: 42px !important; height: 42px !important; color: #111111 !important; background: transparent !important; border: 0 !important; border-radius: 8px !important; }',
    '.rdp-day_disabled { color: #aaaaaa !important; opacity: 1 !important; }',
    '.rdp-day_selected, .rdp-day_selected:hover, .rdp-day_selected:focus { color: #ffffff !important; background: #111111 !important; border-radius: 50% !important; }',
    '.rdp-day:not(.rdp-day_disabled):not(.rdp-day_selected):hover, .rdp-day:not(.rdp-day_disabled):not(.rdp-day_selected):focus { color: #111111 !important; background: #e9e9e9 !important; }',
    '.rdp-nav_button, .widget-container section button { color: #111111 !important; background: #ffffff !important; border: 1px solid #111111 !important; border-radius: 7px !important; box-shadow: none !important; }',
    '.bta-react-select__control { min-height: 44px !important; color: #111111 !important; background: #ffffff !important; border: 1px solid #111111 !important; border-radius: 8px !important; box-shadow: none !important; }',
    '.bta-react-select__single-value, .bta-react-select__input-container, .bta-react-select__indicator { color: #111111 !important; }',
    '.bta-react-select__menu, .bta-react-select__menu-list, .bta-react-select__option { color: #111111 !important; background: #ffffff !important; border-radius: 8px !important; }',
    '.bta-react-select__option--is-focused, .bta-react-select__option--is-selected { color: #111111 !important; background: #d9d9d9 !important; }',
    '.widget-container input:not([type="radio"]), .widget-container select, .widget-container textarea { color: #111111 !important; background: #ffffff !important; border: 1px solid #111111 !important; border-radius: 7px !important; }',
    '.widget-container input[type="radio"] { accent-color: #111111 !important; }',
    '.time-slot-radio-button-list { margin: 14px 0 !important; padding: 0 !important; display: grid !important; grid-template-columns: 1fr !important; gap: 12px !important; }',
    '.time-slot-radio-button-list-element { width: 100% !important; min-height: 76px !important; margin: 0 !important; padding: 14px !important; display: flex !important; align-items: center !important; color: #111111 !important; background: #ffffff !important; border: 1px solid #111111 !important; border-radius: 9px !important; }',
    '.time-slot-radio-button-list-element span { color: #111111 !important; }',
    '.widget-container a { color: #111111 !important; text-decoration: underline !important; }',
    '.timezone-line { width: 100% !important; margin: 18px 0 12px !important; }',
    '.price-container { padding: 10px 0 !important; }',
    '.widget-container .pure-button.fluid { width: 100% !important; min-height: 50px !important; color: #ffffff !important; background: #111111 !important; border: 2px solid #111111 !important; border-radius: 9px !important; box-shadow: none !important; font-weight: 900 !important; }',
    '.widget-container .pure-button.fluid:hover, .widget-container .pure-button.fluid:focus { color: #111111 !important; background: #ffffff !important; }',
    '.ReactModal__Content, .waitlist-modal-form, .confirmation-page { color: #111111 !important; background: #ffffff !important; border-radius: 10px !important; }',
    '*:focus-visible { outline: 3px solid #95c93f !important; outline-offset: 2px !important; }',
    '@media (max-width: 560px) { .widget-container { padding: 18px !important; } .widget-title { font-size: 19px !important; } .rdp-day { width: 38px !important; height: 38px !important; } .time-slot-radio-button-list-element { min-height: 68px !important; } }'
  ].join('\n');

  function addThemeToDocument(frame) {
    try {
      var frameDocument = frame.contentDocument || frame.contentWindow.document;
      if (!frameDocument || !frameDocument.head) return false;

      if (!frameDocument.getElementById(styleId)) {
        var style = frameDocument.createElement('style');
        style.id = styleId;
        style.textContent = widgetCss;
        frameDocument.head.appendChild(style);
      }

      return true;
    } catch (error) {
      return false;
    }
  }

  function addThemeToSrcdoc(frame) {
    if (frame.dataset.nmiBlackSrcdoc === 'true') return false;

    var source = frame.getAttribute('srcdoc');
    if (!source || source.indexOf(styleId) !== -1 || source.indexOf('</head>') === -1) return false;

    frame.dataset.nmiBlackSrcdoc = 'true';
    frame.setAttribute(
      'srcdoc',
      source.replace('</head>', '<style id="' + styleId + '">' + widgetCss + '</style></head>')
    );
    return true;
  }

  function clampBookingWidth(widget, frame) {
    var form = widget.closest('form');
    var container = widget.querySelector('#bta-widget-container');
    var component = widget.querySelector('[id$="-widget-xcomponent"]');

    if (form) {
      form.style.setProperty('width', '100%', 'important');
      form.style.setProperty('max-width', '100%', 'important');
      form.style.setProperty('min-width', '0', 'important');
    }

    widget.style.setProperty('width', '100%', 'important');
    widget.style.setProperty('max-width', '100%', 'important');
    widget.style.setProperty('min-width', '0', 'important');
    widget.style.setProperty('margin', '18px 0 0', 'important');
    widget.style.setProperty('box-sizing', 'border-box', 'important');
    widget.style.setProperty('overflow', 'hidden', 'important');
    widget.style.setProperty('background', '#ffffff', 'important');
    widget.style.setProperty('border', '1px solid #111111', 'important');
    widget.style.setProperty('border-top-width', '8px', 'important');
    widget.style.setProperty('border-radius', '14px', 'important');

    [container, component, frame].forEach(function (element) {
      if (!element) return;
      element.style.setProperty('width', '100%', 'important');
      element.style.setProperty('max-width', '100%', 'important');
      element.style.setProperty('min-width', '0', 'important');
      element.style.setProperty('box-sizing', 'border-box', 'important');
    });

    frame.style.setProperty('display', 'block', 'important');
    frame.style.setProperty('background', '#ffffff', 'important');
    frame.style.setProperty('border', '0', 'important');
    frame.style.setProperty('border-radius', '0 0 13px 13px', 'important');
  }

  function prepareBookingArea() {
    var waitlist = document.querySelector('.nmi-workshop-waitlist');
    if (!waitlist) return false;

    var productMeta = waitlist.closest('.product-single__meta');
    if (productMeta) productMeta.classList.add('nmi-workshop-booking-ready');

    var widget = document.querySelector('#bta-product-widget');
    var frame = widget && widget.querySelector('iframe');
    if (!frame) return false;

    clampBookingWidth(widget, frame);

    if (frame.dataset.nmiBlackThemeListener !== 'true') {
      frame.dataset.nmiBlackThemeListener = 'true';
      frame.addEventListener('load', function () {
        addThemeToDocument(frame);
      });
    }

    return addThemeToDocument(frame) || addThemeToSrcdoc(frame);
  }

  function initialize() {
    prepareBookingArea();

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (prepareBookingArea() || attempts >= 60) window.clearInterval(timer);
    }, 250);

    var observer = new MutationObserver(function () {
      prepareBookingArea();
    });

    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
